import { Flex } from "@redotech/arbiter/flex";
import { Tooltip } from "@redotech/arbiter/tooltip/tooltip";
import HelpCircleIcon from "@redotech/redo-icons/help-circle.svg";
import { memo } from "react";

/** Question-mark icon next to a heading that shows its help text on hover. */
export const SettingsHelpIcon = memo(function SettingsHelpIcon({
  text,
  size = 16,
}: {
  text: string;
  size?: number;
}) {
  return (
    <Tooltip arrow leftAlign title={text}>
      <Flex shrink={0} textColor="tertiary">
        <HelpCircleIcon height={size} width={size} />
      </Flex>
    </Tooltip>
  );
});
